import React from 'react';
import { Fab, CircularProgress, withStyles, Tooltip } from "@material-ui/core";
import Colors from "../../../../template/Colors";
import {
    Print as PrintIcon,
    FileCopy as DuplicateIcon,
    Save as SaveIcon,
    Assignment as AssignmentIcon
} from "@material-ui/icons";
import CloseIcon from '../../../../components/Icon/Close';
import { TypeModalEnumTGO } from '../../../../stores/TGO.store';
import ArrowDownloadIcon from '../../../../components/Icon/ArrowDownload';

const ActionButtons = ({ 
  classes,
  readOnly,
  signedUrl,
  guiaServico,
  typeModal,
  loadingSave,
  loadingPrint,
  onSave,
  handlePrint,
  handleClose,
  handleCopyTGO
 }) => (
<div>
    {typeModal === TypeModalEnumTGO.TGO_MODAL ? (
      <>
        {readOnly && signedUrl && (
          <Tooltip title="Baixar guia GTO assinada" placement="bottom">
            <Fab className={classes.buttonImpressao} disabled={loadingPrint}>
              {loadingPrint ? (
                <CircularProgress size={25} />
              ) : (
                <a
                  id="prt-gtg-btn-bai"
                  href={signedUrl}
                  download={`guia_servico_${guiaServico?.id}.pdf`}
                  target="_blank"
                  rel="noreferrer"
                  className={classes.downloadIconLink}
                >
                  <ArrowDownloadIcon color="white" />
                </a>
              )}
            </Fab>
          </Tooltip>
        )}

        {readOnly && (
          <Tooltip title="Duplicar" placement="bottom">
            <Fab
              id="prt-gtg-btn-dup"
              className={classes.buttonImpressao}
              onClick={handleCopyTGO}
              disabled={loadingPrint}
            >
              {loadingPrint ? <CircularProgress size={25} /> : <DuplicateIcon color="white" />}
            </Fab>
          </Tooltip>
        )}

        <Tooltip title="Guia GTO" placement="bottom">
          <Fab
            id="prt-gtg-btn-gco"
            className={classes.buttonImpressao}
            onClick={() => handlePrint('guiaCompleta')}
            disabled={loadingPrint}
          >
            {loadingPrint ? <CircularProgress size={25} /> : <PrintIcon />}
          </Fab>
        </Tooltip>

        <Tooltip title="Guia GTO como documento" placement="bottom">
          <Fab
            id="prt-gtg-btn-gsi"
            className={classes.buttonImpressao}
            onClick={() => handlePrint('guiaSimples')}
            disabled={loadingPrint}
          >
            {loadingPrint ? <CircularProgress size={25} /> : <AssignmentIcon />}
          </Fab>
        </Tooltip>
      </>
    ) : (
      <Fab
        id="prt-gtg-btn-slv"
        className={classes.buttonActionSave}
        onClick={onSave}
        disabled={loadingSave}
      >
        {loadingSave ? <CircularProgress size={25} /> : <SaveIcon />}
      </Fab>
    )}

    <Fab id="prt-gtg-btn-fch" className={classes.buttonActionClose} onClick={handleClose}>
      <CloseIcon />
    </Fab>
  </div>
);

const styles = (theme) => ({
  buttonActionSave: {
    background: Colors.commons.secondary,
    width: "35px",
    height: "35px",
    color: "white",
    marginLeft: 10,
    boxShadow: "none",
    "&:hover": {
      background: Colors.primary.dark,
    },
  },
  downloadIconLink: {
    display: "flex",
    alignItems: "center",
  },
  buttonActionClose: {
    background: Colors.error.main,
    width: "35px",
    height: "35px",
    color: "white",
    marginLeft: 10,
    boxShadow: "none",
    "&:hover": {
      background: Colors.error.dark,
    },
  },
  buttonActionPrint: {
    width: "35px",
    height: "35px",
    color: "white",
    marginLeft: 10,
    boxShadow: "none",
    background: Colors.commons.yellow,
    "&:hover": {
      background: "#e0a048",
    },
  },
  buttonImpressao: {
    backgroundColor: "#26ACA9",
    width: "40px",
    height: "40px",
    color: "white",
    marginLeft: "10px",
    "&:hover": {
      background: Colors.primary.dark,
    },
  },
});

export default withStyles(styles)(ActionButtons);